import type { Tenant } from './types';

export const mockTenants: Tenant[] = [
  {
    id: 'T10001',
    name: '阿里巴巴集团',
    status: 'active',
    type: 'enterprise',
    createDate: '2024-01-15 10:30:25',
    adminUsername: 'alibaba_admin',
    adminName: '张经理',
    adminUserId: 'U001',
    updateDate: '2024-03-20 14:22:10',
    creator: 'system_admin',
    remark: '大型互联网企业客户',
    userCount: 1250,
    contact: '张经理',
    contactPhone: '13800138001',
    datacenter: '杭州数据中心',
    datacenters: ['杭州数据中心', '上海数据中心'],
    adminInfo: {
      userId: 'U001',
      username: 'alibaba_admin',
      name: '张经理',
      phone: '13800138001'
    },
    enterpriseInfo: {
      license: {
        fileUrl: '/uploads/license_alibaba.pdf',
        fileName: '营业执照_阿里巴巴.pdf'
      },
      name: '阿里巴巴集团控股有限公司',
      creditCode: '91330000MA27XN1234',
      legalPersonName: '张勇',
      legalPersonIdCard: '330106198501011234',
      businessAddress: '浙江省杭州市余杭区文一西路969号'
    },
    wallet: {
      balance: 285600.50,
      totalRecharge: 500000.00,
      totalConsumption: 214399.50
    },
    networkInfo: {
      datacenter: '杭州数据中心',
      latency: 12,
      packetLoss: 0.1,
      bandwidth: '1000 Mbps',
      status: 'normal'
    },
    datacenterNetworks: [
      {
        datacenter: '杭州数据中心',
        latency: 12,
        packetLoss: 0.1,
        bandwidth: '1000 Mbps',
        status: 'normal',
        uptime: 99.8
      },
      {
        datacenter: '上海数据中心',
        latency: 18,
        packetLoss: 0.15,
        bandwidth: '800 Mbps',
        status: 'normal',
        uptime: 99.5
      }
    ],
    rechargeLogs: [
      { id: 1, account: 'alibaba_admin', ip: '192.168.1.100', time: '2024-03-15 09:30:00', amount: 100000 },
      { id: 2, account: 'alibaba_admin', ip: '192.168.1.100', time: '2024-02-20 14:20:00', amount: 150000 },
      { id: 3, account: 'finance_user', ip: '192.168.1.105', time: '2024-01-25 11:15:00', amount: 250000 }
    ]
  },
  {
    id: 'T10002',
    name: '山东科技大学',
    status: 'active',
    type: 'school',
    createDate: '2024-02-10 09:15:30',
    adminUsername: 'sdust_admin',
    adminName: '李主任',
    adminUserId: 'U002',
    updateDate: '2024-03-22 16:45:20',
    creator: 'system_admin',
    remark: '重点合作高校',
    userCount: 3580,
    contact: '李主任',
    contactPhone: '13900139002',
    datacenter: '青岛数据中心',
    datacenters: ['青岛数据中心'],
    adminInfo: {
      userId: 'U002',
      username: 'sdust_admin',
      name: '李主任',
      phone: '13900139002'
    },
    schoolInfo: {
      name: '山东科技大学',
      province: '山东省',
      city: '青岛市',
      district: '黄岛区',
      detailAddress: '前湾港路579号',
      type: 'university'
    },
    wallet: {
      balance: 0,
      totalRecharge: 0,
      totalConsumption: 0
    },
    points: {
      available: 850000,
      configured: 1200000,
      consumed: 350000,
      remaining: 850000,
      totalRecharge: 1200000,
      totalConsumption: 350000,
      totalExpired: 0
    },
    networkInfo: {
      datacenter: '青岛数据中心',
      latency: 8,
      packetLoss: 0.05,
      bandwidth: '2000 Mbps',
      status: 'normal'
    },
    datacenterNetworks: [
      {
        datacenter: '青岛数据中心',
        latency: 8,
        packetLoss: 0.05,
        bandwidth: '2000 Mbps',
        status: 'normal',
        uptime: 99.9
      }
    ],
    rechargeLogs: [
      { id: 4, account: 'sdust_admin', ip: '10.20.30.40', time: '2024-03-10 10:00:00', amount: 500000 },
      { id: 5, account: 'sdust_admin', ip: '10.20.30.40', time: '2024-02-15 09:30:00', amount: 700000 }
    ]
  },
  {
    id: 'T10003',
    name: '腾讯科技有限公司',
    status: 'active',
    type: 'enterprise',
    createDate: '2024-01-20 11:20:15',
    adminUsername: 'tencent_admin',
    adminName: '王总监',
    adminUserId: 'U003',
    updateDate: '2024-03-21 10:30:45',
    creator: 'sales_manager',
    remark: '战略合作伙伴',
    userCount: 2100,
    contact: '王总监',
    contactPhone: '13700137003',
    datacenter: '深圳数据中心',
    datacenters: ['深圳数据中心', '广州数据中心', '北京数据中心'],
    adminInfo: {
      userId: 'U003',
      username: 'tencent_admin',
      name: '王总监',
      phone: '13700137003'
    },
    enterpriseInfo: {
      license: {
        fileUrl: '/uploads/license_tencent.pdf',
        fileName: '营业执照_腾讯.pdf'
      },
      name: '深圳市腾讯计算机系统有限公司',
      creditCode: '91440300708461136T',
      legalPersonName: '马化腾',
      legalPersonIdCard: '440305197104125678',
      businessAddress: '广东省深圳市南山区科技园科技中一路腾讯大厦'
    },
    wallet: {
      balance: 520800.00,
      totalRecharge: 800000.00,
      totalConsumption: 279200.00
    },
    networkInfo: {
      datacenter: '深圳数据中心',
      latency: 10,
      packetLoss: 0.08,
      bandwidth: '1500 Mbps',
      status: 'normal'
    },
    datacenterNetworks: [
      {
        datacenter: '深圳数据中心',
        latency: 10,
        packetLoss: 0.08,
        bandwidth: '1500 Mbps',
        status: 'normal',
        uptime: 99.7
      },
      {
        datacenter: '广州数据中心',
        latency: 15,
        packetLoss: 0.12,
        bandwidth: '1200 Mbps',
        status: 'normal',
        uptime: 99.6
      },
      {
        datacenter: '北京数据中心',
        latency: 25,
        packetLoss: 0.2,
        bandwidth: '1000 Mbps',
        status: 'normal',
        uptime: 99.4
      }
    ],
    rechargeLogs: [
      { id: 6, account: 'tencent_admin', ip: '172.16.10.50', time: '2024-03-18 15:20:00', amount: 300000 },
      { id: 7, account: 'finance_dept', ip: '172.16.10.55', time: '2024-02-10 11:00:00', amount: 500000 }
    ]
  },
  {
    id: 'T10004',
    name: '清华大学',
    status: 'active',
    type: 'school',
    createDate: '2024-02-05 14:30:00',
    adminUsername: 'tsinghua_admin',
    adminName: '赵教授',
    adminUserId: 'U004',
    updateDate: '2024-03-23 09:15:30',
    creator: 'system_admin',
    remark: '顶尖高校合作',
    userCount: 4200,
    contact: '赵教授',
    contactPhone: '13600136004',
    datacenter: '北京数据中心',
    datacenters: ['北京数据中心', '上海数据中心'],
    adminInfo: {
      userId: 'U004',
      username: 'tsinghua_admin',
      name: '赵教授',
      phone: '13600136004'
    },
    schoolInfo: {
      name: '清华大学',
      province: '北京市',
      city: '北京市',
      district: '海淀区',
      detailAddress: '清华园1号',
      type: 'university'
    },
    wallet: {
      balance: 0,
      totalRecharge: 0,
      totalConsumption: 0
    },
    points: {
      available: 1650000,
      configured: 2000000,
      consumed: 350000,
      remaining: 1650000,
      totalRecharge: 2000000,
      totalConsumption: 350000,
      totalExpired: 0
    },
    networkInfo: {
      datacenter: '北京数据中心',
      latency: 5,
      packetLoss: 0.02,
      bandwidth: '3000 Mbps',
      status: 'normal'
    },
    datacenterNetworks: [
      {
        datacenter: '北京数据中心',
        latency: 5,
        packetLoss: 0.02,
        bandwidth: '3000 Mbps',
        status: 'normal',
        uptime: 99.95
      },
      {
        datacenter: '上海数据中心',
        latency: 12,
        packetLoss: 0.08,
        bandwidth: '2500 Mbps',
        status: 'normal',
        uptime: 99.8
      }
    ],
    rechargeLogs: [
      { id: 8, account: 'tsinghua_admin', ip: '10.10.10.10', time: '2024-03-01 08:00:00', amount: 1000000 },
      { id: 9, account: 'tsinghua_admin', ip: '10.10.10.10', time: '2024-02-01 08:00:00', amount: 1000000 }
    ]
  },
  {
    id: 'T10005',
    name: '字节跳动科技有限公司',
    status: 'disabled',
    type: 'enterprise',
    createDate: '2024-01-25 16:45:20',
    adminUsername: 'bytedance_admin',
    adminName: '刘经理',
    adminUserId: 'U005',
    updateDate: '2024-03-19 13:20:15',
    creator: 'sales_manager',
    remark: '暂停合作',
    userCount: 1800,
    contact: '刘经理',
    contactPhone: '13500135005',
    datacenter: '北京数据中心',
    datacenters: ['北京数据中心'],
    adminInfo: {
      userId: 'U005',
      username: 'bytedance_admin',
      name: '刘经理',
      phone: '13500135005'
    },
    enterpriseInfo: {
      license: {
        fileUrl: '/uploads/license_bytedance.pdf',
        fileName: '营业执照_字节跳动.pdf'
      },
      name: '北京字节跳动科技有限公司',
      creditCode: '91110108MA01GKQ123',
      legalPersonName: '张一鸣',
      legalPersonIdCard: '350102198303159012',
      businessAddress: '北京市海淀区知春路甲48号盈都大厦C座'
    },
    wallet: {
      balance: 15600.00,
      totalRecharge: 300000.00,
      totalConsumption: 284400.00
    },
    networkInfo: {
      datacenter: '北京数据中心',
      latency: 15,
      packetLoss: 0.3,
      bandwidth: '1000 Mbps',
      status: 'maintenance'
    },
    datacenterNetworks: [
      {
        datacenter: '北京数据中心',
        latency: 15,
        packetLoss: 0.3,
        bandwidth: '1000 Mbps',
        status: 'maintenance',
        uptime: 95.2
      }
    ],
    rechargeLogs: [
      { id: 10, account: 'bytedance_admin', ip: '192.168.50.100', time: '2024-02-28 10:30:00', amount: 100000 },
      { id: 11, account: 'finance_team', ip: '192.168.50.105', time: '2024-01-30 14:00:00', amount: 200000 }
    ]
  },
  {
    id: 'T10006',
    name: '北京市第四中学',
    status: 'active',
    type: 'school',
    createDate: '2024-02-15 10:00:00',
    adminUsername: 'bj4_admin',
    adminName: '孙校长',
    adminUserId: 'U006',
    updateDate: '2024-03-20 11:30:00',
    creator: 'system_admin',
    remark: '重点中学',
    userCount: 1200,
    contact: '孙校长',
    contactPhone: '13400134006',
    datacenter: '北京数据中心',
    datacenters: ['北京数据中心'],
    adminInfo: {
      userId: 'U006',
      username: 'bj4_admin',
      name: '孙校长',
      phone: '13400134006'
    },
    schoolInfo: {
      name: '北京市第四中学',
      province: '北京市',
      city: '北京市',
      district: '西城区',
      detailAddress: '西黄城根北街甲2号',
      type: 'high'
    },
    wallet: {
      balance: 0,
      totalRecharge: 0,
      totalConsumption: 0
    },
    points: {
      available: 280000,
      configured: 500000,
      consumed: 220000,
      remaining: 280000,
      totalRecharge: 500000,
      totalConsumption: 220000,
      totalExpired: 0
    },
    networkInfo: {
      datacenter: '北京数据中心',
      latency: 6,
      packetLoss: 0.03,
      bandwidth: '1000 Mbps',
      status: 'normal'
    },
    datacenterNetworks: [
      {
        datacenter: '北京数据中心',
        latency: 6,
        packetLoss: 0.03,
        bandwidth: '1000 Mbps',
        status: 'normal',
        uptime: 99.85
      }
    ],
    rechargeLogs: [
      { id: 12, account: 'bj4_admin', ip: '10.50.60.70', time: '2024-03-05 09:00:00', amount: 300000 },
      { id: 13, account: 'bj4_admin', ip: '10.50.60.70', time: '2024-02-20 10:00:00', amount: 200000 }
    ]
  },
  {
    id: 'T10007',
    name: '华为技术有限公司',
    status: 'active',
    type: 'enterprise',
    createDate: '2024-01-18 09:30:00',
    adminUsername: 'huawei_admin',
    adminName: '周总',
    adminUserId: 'U007',
    updateDate: '2024-03-22 15:45:00',
    creator: 'system_admin',
    remark: '长期合作伙伴',
    userCount: 3500,
    contact: '周总',
    contactPhone: '13300133007',
    datacenter: '深圳数据中心',
    datacenters: ['深圳数据中心', '北京数据中心'],
    adminInfo: {
      userId: 'U007',
      username: 'huawei_admin',
      name: '周总',
      phone: '13300133007'
    },
    enterpriseInfo: {
      license: {
        fileUrl: '/uploads/license_huawei.pdf',
        fileName: '营业执照_华为.pdf'
      },
      name: '华为技术有限公司',
      creditCode: '91440300618520432Y',
      legalPersonName: '任正非',
      legalPersonIdCard: '522301194410127890',
      businessAddress: '广东省深圳市龙岗区坂田华为总部办公楼'
    },
    wallet: {
      balance: 680500.00,
      totalRecharge: 1000000.00,
      totalConsumption: 319500.00
    },
    networkInfo: {
      datacenter: '深圳数据中心',
      latency: 9,
      packetLoss: 0.06,
      bandwidth: '2000 Mbps',
      status: 'normal'
    },
    datacenterNetworks: [
      {
        datacenter: '深圳数据中心',
        latency: 9,
        packetLoss: 0.06,
        bandwidth: '2000 Mbps',
        status: 'normal',
        uptime: 99.75
      },
      {
        datacenter: '北京数据中心',
        latency: 22,
        packetLoss: 0.18,
        bandwidth: '1500 Mbps',
        status: 'normal',
        uptime: 99.5
      }
    ],
    rechargeLogs: [
      { id: 14, account: 'huawei_admin', ip: '172.20.30.40', time: '2024-03-12 14:00:00', amount: 500000 },
      { id: 15, account: 'finance_dept', ip: '172.20.30.45', time: '2024-02-05 10:30:00', amount: 500000 }
    ]
  },
  {
    id: 'T10008',
    name: '上海交通大学',
    status: 'active',
    type: 'school',
    createDate: '2024-02-08 11:15:00',
    adminUsername: 'sjtu_admin',
    adminName: '吴院长',
    adminUserId: 'U008',
    updateDate: '2024-03-21 14:20:00',
    creator: 'system_admin',
    remark: '985高校',
    userCount: 3800,
    contact: '吴院长',
    contactPhone: '13200132008',
    datacenter: '上海数据中心',
    datacenters: ['上海数据中心'],
    adminInfo: {
      userId: 'U008',
      username: 'sjtu_admin',
      name: '吴院长',
      phone: '13200132008'
    },
    schoolInfo: {
      name: '上海交通大学',
      province: '上海市',
      city: '上海市',
      district: '闵行区',
      detailAddress: '东川路800号',
      type: 'university'
    },
    wallet: {
      balance: 0,
      totalRecharge: 0,
      totalConsumption: 0
    },
    points: {
      available: 1420000,
      configured: 1800000,
      consumed: 380000,
      remaining: 1420000,
      totalRecharge: 1800000,
      totalConsumption: 380000,
      totalExpired: 0
    },
    networkInfo: {
      datacenter: '上海数据中心',
      latency: 7,
      packetLoss: 0.04,
      bandwidth: '2500 Mbps',
      status: 'normal'
    },
    datacenterNetworks: [
      {
        datacenter: '上海数据中心',
        latency: 7,
        packetLoss: 0.04,
        bandwidth: '2500 Mbps',
        status: 'normal',
        uptime: 99.88
      }
    ],
    rechargeLogs: [
      { id: 16, account: 'sjtu_admin', ip: '10.30.40.50', time: '2024-03-08 09:30:00', amount: 900000 },
      { id: 17, account: 'sjtu_admin', ip: '10.30.40.50', time: '2024-02-12 10:00:00', amount: 900000 }
    ]
  }
];

// 平台用户列表，用于搜索和选择租户管理员
export const mockPlatformUsers = [
  { userId: 'U001', username: 'alibaba_admin', name: '张经理', phone: '13800138001', status: 'active', department: '运营部' },
  { userId: 'U002', username: 'sdust_admin', name: '李主任', phone: '13900139002', status: 'active', department: '教务处' },
  { userId: 'U003', username: 'tencent_admin', name: '王总监', phone: '13700137003', status: 'active', department: '技术部' },
  { userId: 'U004', username: 'tsinghua_admin', name: '赵教授', phone: '13600136004', status: 'active', department: '计算机系' },
  { userId: 'U005', username: 'bytedance_admin', name: '刘经理', phone: '13500135005', status: 'active', department: '产品部' },
  { userId: 'U006', username: 'bj4_admin', name: '孙校长', phone: '13400134006', status: 'active', department: '校长办公室' },
  { userId: 'U007', username: 'huawei_admin', name: '周总', phone: '13300133007', status: 'active', department: '研发部' },
  { userId: 'U008', username: 'sjtu_admin', name: '吴院长', phone: '13200132008', status: 'active', department: '信息学院' },
  { userId: 'U009', username: 'baidu_admin', name: '陈主管', phone: '13100131009', status: 'active', department: 'AI部门' },
  { userId: 'U010', username: 'xiaomi_admin', name: '林总', phone: '13000130010', status: 'active', department: '硬件部' },
  { userId: 'U011', username: 'didi_admin', name: '郭经理', phone: '12900129011', status: 'active', department: '运营部' },
  { userId: 'U012', username: 'meituan_admin', name: '何主任', phone: '12800128012', status: 'active', department: '技术部' },
  { userId: 'U013', username: 'jd_admin', name: '谢总监', phone: '12700127013', status: 'active', department: '商务部' },
  { userId: 'U014', username: 'netease_admin', name: '徐经理', phone: '12600126014', status: 'active', department: '游戏部' },
  { userId: 'U015', username: 'sina_admin', name: '韩主管', phone: '12500125015', status: 'active', department: '内容部' }
];

export const mockAdmins = [
  { phone: '13800138001', username: 'alibaba_admin', name: '张经理' },
  { phone: '13900139002', username: 'sdust_admin', name: '李主任' },
  { phone: '13700137003', username: 'tencent_admin', name: '王总监' },
  { phone: '13600136004', username: 'tsinghua_admin', name: '赵教授' },
  { phone: '13500135005', username: 'bytedance_admin', name: '刘经理' },
  { phone: '13400134006', username: 'bj4_admin', name: '孙校长' },
  { phone: '13300133007', username: 'huawei_admin', name: '周总' },
  { phone: '13200132008', username: 'sjtu_admin', name: '吴院长' }
];

export const mockDatacenters = [
  '北京数据中心',
  '上海数据中心',
  '深圳数据中心',
  '杭州数据中心',
  '青岛数据中心',
  '成都数据中心',
  '广州数据中心'
];
